import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const FEATURE_ITEM_SCHEMA = [
  {
    key: "icon",
    label: "Icon",
    type: "select" as const,
    options: [
      { label: "Shipping Truck", value: "shipping" },
      { label: "Return Arrow", value: "refund" },
      { label: "Support Headset", value: "support" },
      { label: "Security Lock", value: "secure" },
      { label: "Gift Box", value: "gift" },
    ],
    default: "shipping",
  },
  { key: "title", label: "Title", type: "string" as const },
  { key: "subtitle", label: "Subtitle", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "features",
  label: "Features Strip",
  description: "Trust-building feature strip showing shipping, returns, support, and security highlights.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Compact Horizontal Strip",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: FEATURE_ITEM_SCHEMA },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (Light Gray)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" },
          ],
          default: "default",
        },
      ],
    },
    {
      id: "v2",
      label: "V2 — Spaced Cards",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: FEATURE_ITEM_SCHEMA },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (White)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" },
          ],
          default: "default",
        },
      ],
    },
    {
      id: "v3",
      label: "V3 — Jewelry Minimal Centered",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: FEATURE_ITEM_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
